export const GTM_ID: string = 'W3W2V8';
